import type { SVGProps } from 'react';

const SvgMessageWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.19 15.53-5.58-9.92A2.97 2.97 0 0 0 12 4.08c-1.09 0-2.08.57-2.61 1.53l-5.58 9.92c-.53.94-.52 2.06.02 2.99s1.51 1.49 2.59 1.49h11.16c1.08 0 2.05-.56 2.59-1.49s.55-2.05.02-2.99m-1.75 1.98c-.09.15-.35.5-.86.5H6.42c-.52 0-.78-.35-.86-.5a1 1 0 0 1 0-1l5.57-9.92c.26-.46.7-.51.87-.51s.61.05.87.51l5.58 9.92c.25.45.08.85 0 1z"
    />
    <path
      fill="currentcolor"
      d="M12 13c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1m0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
export default SvgMessageWarning;
